export default {
	props: {
		name: {
			type: String,
			required: true
		}
	},
	inject: ["validate", "form"],
	beforeMount() {
		this.$store.commit("form_field_array_register", {
			form: this.form,
			field: this.name
		});
	},
	beforeDestroy() {
		this.$store.commit("form_field_array_unregister", {
			form: this.form,
			field: this.name
		});
	},
	computed: {
		myFields() {
			return this.$store.getters.formArraySubFields(this.form, this.name);
		},
		error() {
			// TODO: add error to array
			return undefined;
			// return this.$store.getters.formFieldError(this.form, this.name);
		},
		showError() {
			return false;
			// return this.meta.touched && !!this.error;
		}
	},
	methods: {
		fieldMove(from, to) {
			this.$store.commit("form_field_array_move", {
				form: this.form,
				field: this.name,
				from,
				to
			});
		},
		fieldPush(value) {
			this.$store.commit("form_field_array_push", {
				form: this.form,
				field: this.name,
				value
			});
			setTimeout(() => {
				this.validate(this.name);
			}, 0);
		},
		fieldRemove(index) {
			this.$store.commit("form_field_array_remove", {
				form: this.form,
				field: this.name,
				index
			});
		}
	}
};
